import * as types from '../mutation-types'
import { api } from '@/modules/api/index'
import { pathOr } from 'ramda'

const state = {
  list: [],
  totalPages: '',
  imgUrl: ''
}

const getters = {
  getGalleries: state => state,
  getImgUrl: state => state.imgUrl
}

const actions = {
  async fetchGalleries ({ commit }, {page, itemsOnPage, category, title}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.galleries.get({page, itemsOnPage, category, title}))
      commit(types.SET_GALLERIES_LIST, data)
      return data
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Fail on fetch galleries')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async uploadImage ({ dispatch, commit }, formData) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios({ method: 'post', url: api.galleries.postImage(), headers: {'Content-type': 'multipart/form-data'}, data: formData })
      let { storedImageResponses } = data
      let galleriesUrls = storedImageResponses.map(response => {
        let { fileName, originalImageUrl, imageTransforms } = response
        let imagesUrls = { originalImageUrl, ...imageTransforms }
        return { imagesUrls, id: fileName }
      })
      return galleriesUrls
    } catch (err) {
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async deleteImage ({ dispatch, commit }, ids) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.galleries.deleteImage(ids))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Image was deleted successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Image Delete Error')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async deleteStorageImage ({ dispatch, commit }, cloudinaryIds) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.galleries.deleteStorageImage(cloudinaryIds))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Image was deleted successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Image Delete Error')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async postImageDetails ({ dispatch, commit }, galleries) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.post(api.galleries.req(), galleries)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Image was uploaded successfully')
      return response.data
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Image wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async postAllImagesDetails ({ dispatch, commit }, galleries) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.post(api.galleries.req(), galleries)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Images were uploaded successfully')
      return response.data
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Images were not uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateImageDetails ({ dispatch, commit }, {id, alt, title, categories}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.put(api.galleries.req(), { id, alt, title, categories })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Image was updated successfully')
      return response.data
    } catch (err) {
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async setImageUrl ({ commit }, imgId) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.galleries.getImgUrl(imgId))
      commit(types.SET_IMAGE_URL, data)
      return data
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Fail on fetch galleries')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_GALLERIES_LIST] (state, galleriesData) {
    state.list = galleriesData.galleries
    state.totalPages = galleriesData.totalPages
  },
  [types.SET_IMAGE_URL] (state, data) {
    state.imgUrl = pathOr('', ['imagesUrls', 'originalImageUrl'], data)
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/galleries.js